import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReactTooltip from 'react-tooltip';

import Select from 'react-select';

import {
  getIcon,
  formatThousands,
  getMonthCountInQuarterForDate,
} from '../../util';

import {
  getDealCompletion
} from '../../util/dealScoring';

import {
  fetchUserDataForEveryone
} from '../../actions';

import {
  fetchSprintHistoryForEveryone
} from '../../actions/sprint';

import {
  fetchDealsForEveryone
} from '../../actions/deals';

const ALL_TEAMS_OPTION = {
  value: 'everyone',
  label: 'Everyone',
}

const ENTIRE_TEAM_OPTION = {
  value: false,
  userData: null,
  label: 'Entire Team',
}

const DEFAULT_START_DATE = moment().startOf('isoWeek').subtract(7, 'days').format('YYYYMMDD');

class WinTheWeekReport extends Component {

  state = {
    viewingTeam: 'everyone',
    viewingTeamUser: false,
    userData: {},
    //reportWeekStart: '20190325',
    //reportWeekStart: '20190520'
    reportWeekStart: DEFAULT_START_DATE
  }

  componentDidMount(){
    this.props.fetchDealsForEveryone();
    this.props.fetchSprintHistoryForEveryone();
    this.props.fetchUserDataForEveryone(userData => {
      // console.log('found user data: ', userData);
      this.setState({
        userData: _.keyBy(userData, '_id')
      });
    }, true);
  }

  getReportDates(){
    const reportStartDate = moment(this.state.reportWeekStart);

    return {
      thisStart: reportStartDate,
      thisEnd: moment(reportStartDate).clone().add(4, 'days'),
      lastStart: moment(reportStartDate).clone().subtract(7, 'days'),
      lastEnd: moment(reportStartDate).clone().subtract(3, 'days')
    }
  }

  goToPrevWeek(){
    this.setState({
      reportWeekStart: moment(this.state.reportWeekStart).subtract(7, 'days').format('YYYYMMDD')
    });
  }
  goToNextWeek(){
    if(this.state.reportWeekStart === DEFAULT_START_DATE){
      return;
    }

    this.setState({
      reportWeekStart: moment(this.state.reportWeekStart).add(7, 'days').format('YYYYMMDD')
    });
  }

  sprintsForWeek(allSprints, startDate, endDate){
    return _.filter(allSprints, sprint => {
      return sprint.startDate === startDate.format('YYYYMMDD') && sprint.endDate === endDate.format('YYYYMMDD');
    }) || [];
  }

  filterItemsForReportViewingTeamOrUser(items){
    let filterByUserIds = null;

    // console.log(this.viewingUserData());
    // console.log(this.viewingTeamData());

    if(this.viewingUserData()){
      filterByUserIds = [ this.viewingUserData()._id ];
    }
    else if(this.viewingTeamData()){
      filterByUserIds = [ ...this.viewingTeamData().leaders, ...this.viewingTeamData().members ];
    }

    if(filterByUserIds){
      return _.filter(items, item => {
        return filterByUserIds.indexOf(item.userId) !== -1;
      });
    }
    else{
      return items;
    }
  }

  getGoalCompletedAndAvailable(goal){

    const {goalType, goalValue, goalTarget, goalTargets} = goal;

    if(goalType === 'forecast'){
      return {
        completed: goalValue || 0,
        available: goalTargets ? goalTargets[getMonthCountInQuarterForDate(this.getReportDates().thisEnd)] : goalTarget,
      }
    }
    else if(goalType === 'measure'){
      return {
        completed: goalValue || 0,
        available: goalTarget,
      }
    }
    else if(goalType === 'do'){
      return {
        completed: 0 + ((goalValue || {}).applied ? 1 : 0) + ((goalValue || {}).practiced ? 1 : 0) + ((goalValue || {}).improved ? 1 : 0),
        available: 3,
      }
    }
    else{
      return { completed: 0, available: 0 }
    }
  }

  labelForGoalId(id){
    return (_.find(this.props.goalOptions, {id}) || {}).name;
  }

  datasetForReportRange(startDate, endDate){

    let reportDataset = {

      //Sprint related
      outcome: {
        items: {}
      },
      activity: {
        completedItemsCount: 0,
        itemCompletion: 0,
        itemsAvailable: 0,
        completedTotal: 0,
        availableTotal: 0,
        items: {}
      },
      behavior: {
        completedTotal: 0,
        availableTotal: 0,
        items: {}
      },
      skill: {
        completedTotal: 0,
        availableTotal: 0,
        items: {}
      },

      //Deal related
      deals: {
        won: {
          count: 0,
        },
        new: {
          count: 0
        },
        pipeline: 0,
        adjustedPipeline: 0,
        stages: {

        }
      }

    };

    const allMatchingSprints = this.sprintsForWeek(this.filterItemsForReportViewingTeamOrUser(this.props.sprintHistory), startDate, endDate);
    const allMatchingDeals = this.filterItemsForReportViewingTeamOrUser(this.props.deals);

    if(!allMatchingSprints || !allMatchingDeals){
      return reportDataset;
    }
    // console.log('allMatchingSprints: ', allMatchingSprints.length);
    // console.log('allMatchingDeals: ', allMatchingDeals.length);

    _.each(allMatchingSprints, sprintData => {
      _.each(sprintData.goals, goal => {
        if(!reportDataset[goal.category].items[goal.id]){
          reportDataset[goal.category].items[goal.id] = {
            label: this.labelForGoalId(goal.id),
            completed: 0,
            available: 0,
          }
        }

        const goalCompletedAndAvailable = this.getGoalCompletedAndAvailable(goal);

        reportDataset[goal.category].items[goal.id].completed += goalCompletedAndAvailable.completed;
        reportDataset[goal.category].items[goal.id].available += goalCompletedAndAvailable.available;

        if(goal.category !== 'outcome'){
          reportDataset[goal.category].completedTotal += goalCompletedAndAvailable.completed;
          reportDataset[goal.category].availableTotal += goalCompletedAndAvailable.available;
        }

        if(goal.category === 'activity'){
          if(goalCompletedAndAvailable.completed >= goalCompletedAndAvailable.available){
            reportDataset[goal.category].completedItemsCount++;
          }

          reportDataset[goal.category].itemCompletion += Math.min((goalCompletedAndAvailable.completed / goalCompletedAndAvailable.available), 1);
          reportDataset[goal.category].itemsAvailable++;
        }
      });
    });

    _.each(allMatchingDeals, deal => {
      /*
      won: 0,
      new: 0,
      pipeline: 0,
      adjustedPipeline: 0,
      */

      const dealCloseDaysFromReportStart = moment(deal.estimatedCloseDate).diff(startDate, 'days');
      const dealDaysFromReportStart = moment(deal.createdOn.toDate()).diff(startDate, 'days');

      const dealCompletion = getDealCompletion(deal);

      // console.log('startDate: ', startDate);
      // console.log('deal est close date: ', deal.estimatedCloseDate);
      // console.log('created on: ', deal.createdOn);
      // console.log('dealCloseDaysFromReportStart: ', dealCloseDaysFromReportStart);

      if(dealDaysFromReportStart > 0 && dealDaysFromReportStart < 7){
        reportDataset.deals.new.count++;
      }
      if(deal.status === 'won' && dealCloseDaysFromReportStart > 0 && dealCloseDaysFromReportStart < 7){
        reportDataset.deals.won.count++;
      }
      if(deal.status === 'open'){
        reportDataset.deals.pipeline += (deal.estimatedValue || 0);
        reportDataset.deals.adjustedPipeline += (dealCompletion.confidence / 100) * deal.estimatedValue;
      }

      //if(deal.createdOn)
    });

    return reportDataset;
  }

  reportData(){
    const lastWeekData = this.datasetForReportRange(this.getReportDates().lastStart,this.getReportDates().lastEnd);
    const thisWeekData = this.datasetForReportRange(this.getReportDates().thisStart,this.getReportDates().thisEnd);

    const reportData = {};

    reportData.outcome = thisWeekData.outcome;
    reportData.activity = thisWeekData.activity;
    reportData.behavior = thisWeekData.behavior;
    reportData.skill = thisWeekData.skill;
    reportData.deals = thisWeekData.deals;

    _.each(['outcome', 'behavior', 'skill', 'activity'], goalCategory => {
      _.each(reportData[goalCategory].items, (item, itemIndex) => {
        if(lastWeekData[goalCategory].items[itemIndex] && lastWeekData[goalCategory].items[itemIndex].completed && lastWeekData[goalCategory].items[itemIndex].available){
          const thisWeekPercentage = item.completed / item.available;
          const lastWeekPercentage = lastWeekData[goalCategory].items[itemIndex].completed / lastWeekData[goalCategory].items[itemIndex].available;
          item.delta = Math.round(((thisWeekPercentage - lastWeekPercentage)/(lastWeekPercentage)) * 100);
        }
      });
    });

    reportData.activity.delta = Math.round((thisWeekData.activity.completedItemsCount - lastWeekData.activity.completedItemsCount) * 100 / lastWeekData.activity.completedItemsCount);

    reportData.deals.new.delta = Math.round((thisWeekData.deals.new.count - lastWeekData.deals.new.count) * 100 / lastWeekData.deals.new.count);
    reportData.deals.won.delta = Math.round((thisWeekData.deals.won.count - lastWeekData.deals.won.count) * 100 / lastWeekData.deals.won.count);

    return reportData;
  }

  getDatasetForUserAndTeamReport(){
    return this.entireDatasetForReport();
  }

  viewingTeamData(){
    return _.find(this.props.teams, { _id: this.state.viewingTeam });
  }

  userData(userId){
    return this.state.userData[userId];
  }

  viewingUserData(){
    if(!this.state.viewingTeamUser){ return null; }
    return this.state.userData[this.state.viewingTeamUser] || null;
  }

  getTeamUsersOptions(){
    if(!this.viewingTeamData()){
      return [];
    }

    const {
      leaders,
      members
    } = this.viewingTeamData();

    const memberOptions = _.map(_.union(leaders, members), userId => {

      const userData = this.userData(userId);

      return {
        value: userId,
        label: `${userData.firstName} ${userData.lastName}`
      };

    });

    return [
      ENTIRE_TEAM_OPTION,
      ...memberOptions,
    ];
  }

  viewTeam(teamId){
    this.setState({
      viewingTeam: teamId,
      viewingTeamUser: false,
    });
  }

  viewTeamUser(userId){
    this.setState({
      viewingTeamUser: userId,
    });
  }

  getTeamOptions(){
    const { teams } = this.props;

    let teamOptions = [];

    _.each(teams || [], team => {
      teamOptions.push({
        value: team._id,
        label: team.name
      });
    });

    return [
      ALL_TEAMS_OPTION,
      ...teamOptions
    ]
  }

  getViewingTeamSelectValue(){
    const { viewingTeam } = this.state;

    const matchingTeam = _.find(this.getTeamOptions(), team => {
      return team.value === viewingTeam._id;
    });

    return matchingTeam;
  }

  getViewingTeamUserSelectValue(){
    const { viewingTeamUser } = this.state;

    console.log('viewingTeamUser: ', viewingTeamUser);

    if(!viewingTeamUser){
      return ENTIRE_TEAM_OPTION;
    }

    const matchingTeamUser = _.find(this.getTeamUsersOptions(), user => {
      return user.value === viewingTeamUser;
    });

    return matchingTeamUser || ENTIRE_TEAM_OPTION;
  }

  renderTeamUserSelect(){

    //if viewing all teams, don't render users select
    if(!this.state.viewingTeam === 'everyone'){
      return null;
    }

    const teamUsersOptions = this.getTeamUsersOptions();

    if(!teamUsersOptions || teamUsersOptions.length === 0){
      return null;
    }

    const selectedOption = this.getViewingTeamUserSelectValue();

    return (
      <Select
        classNamePrefix={'react-select'}
        className={`react-select-container member-select ${!selectedOption.value && 'none-selected'}`}
        value={selectedOption}
        options={teamUsersOptions}
        onChange={(option) => { this.viewTeamUser(option.value) }}
        isSearchable={false}
      />
    )
  }

  renderTeamSelect(){

    const teamOptions = this.getTeamOptions();

    if(!teamOptions || teamOptions.length === 0){
      return null;
    }

    return (
      <Select
        classNamePrefix={'react-select'}
        className='react-select-container team-select'
        value={this.getViewingTeamSelectValue()}
        options={teamOptions}
        onChange={(option) => { this.viewTeam(option.value) }}
        isSearchable={false}
      />
    );
  }

  generateTooltipForDelta(delta){
    if(delta > 0){
      return `${delta}% improvement over last week`;
    }
    else if(delta < 0){
      return `${delta}% decline over last week`;
    }
    else{
      return `No change over last week`;
    }
  }
  generateDeltaText(delta){
    return `${delta > 0 ? '+' : ''}${delta}%`;
  }

  renderDelta(delta){
    if(delta === undefined){
      return null;
    }
    else{

      if(delta === Infinity){
        delta = 1000;
      }
      return (
        <React.Fragment>
          <div data-tip={this.generateTooltipForDelta(delta)} data-for={`report-item-delta`} className={`delta ${delta > 0 ? 'up' : 'down'}`}>{this.generateDeltaText(delta)}</div>
          <ReactTooltip id={`report-item-delta`} effect="solid" placement="bottom"/>
        </React.Fragment>
      )
    }
  }

  renderReportDevelopmentItem(item, id){

    const {
      label,
      completed,
      available,
      delta,
    } = item;

    return (
      <div className={`report-item third outcome-item-${id}`}>
        <div className="label">{label}</div>
        <div className={`item-value development ${completed > 0 ? 'not-zero' : 'zero'}`}>{formatThousands(completed)}</div>
        {this.renderDelta(delta)}
      </div>
    )
  }
  renderReportDevelopmentItemGroup(itemGroup, index){
    return (
      <div key={`item-group-${index}`} className="report-item-row">
        {_.map(itemGroup, this.renderReportDevelopmentItem.bind(this))}
      </div>
    )
  }

  renderReportDevelopmentSection(skillsData, behaviorsData){

    const sortedSkills = _.sortBy(skillsData.items, item => {
      return -1 * item.completed;
    });

    const sortedBehaviors = _.sortBy(behaviorsData.items, item => {
      return -1 * item.completed;
    });

    return (
      <div className="report-section">
        <h6>Talent Development</h6>
        <div className="report-items">
          <div className="report-item-header">Skills</div>
          {_.map(_.chunk(sortedSkills, 3), this.renderReportDevelopmentItemGroup.bind(this))}
          <div className="report-item-header">Behaviors</div>
          {_.map(_.chunk(sortedBehaviors, 3), this.renderReportDevelopmentItemGroup.bind(this))}
        </div>
      </div>
    );
  }

  renderReportActivityItem(item, id){

    const {
      label,
      completed,
      available,
      delta
    } = item;

    return (
      <div className={`report-item outcome-item-${id}`}>
        <div className="label">{label}</div>
        <div className="count">{formatThousands(completed)} / {formatThousands(available)}</div>
        <div className="progress-bar">
          <div className="available"></div>
          <div className="completed" style={{width: `${Math.min((completed * 100 / available), 100)}%`}}></div>
          <div className="amount">{Math.ceil(completed * 100 / available)}%</div>
        </div>
        {this.renderDelta(delta)}
      </div>
    )
  }
  renderReportActivitesSection(activitiesData){

    const sortedActivities = _.sortBy(activitiesData.items, item => {
      return -1 * item.completed / item.available;
    });

    return (
      <div className="report-section">
        <h6>Activities</h6>
        <div className="report-items">
          <div className="report-item">
            <div className="label">Team Completion</div>
            <div className="item-value">{Math.ceil(activitiesData.completedItemsCount * 100 /activitiesData.itemsAvailable)}%</div>
              {this.renderDelta(activitiesData.delta)}
          </div>
          <div className="report-item-row">
            {_.map(sortedActivities, this.renderReportActivityItem.bind(this))}
          </div>
        </div>
      </div>
    );
  }

  renderReportOutcomeItem(item, id){

    const {
      label,
      completed,
      available,
      delta,
    } = item;

    return (
      <div className={`report-item outcome-item-${id}`}>
        <div className="label">{label}</div>
        <div className="count">{formatThousands(completed)} / {formatThousands(available)}</div>
        <div className="progress-bar">
          <div className="available"></div>
          <div className="completed" style={{width: `${Math.min((completed * 100 / available), 100)}%`}}></div>
          <div className="amount">{Math.ceil(completed * 100 / available)}%</div>
        </div>
        {this.renderDelta(delta)}
      </div>
    )
  }
  renderReportOutcomesSection(outcomesData){

    return (
      <div className="report-section">
        <h6>Outcomes</h6>
        <div className="report-items">
          {_.map(outcomesData.items, this.renderReportOutcomeItem.bind(this))}
        </div>
      </div>
    );
  }

  renderDealsSection(dealsData){

    return (
      <div className="report-section">
        <h6>Deal Summary</h6>
        <div className="report-items">
          <div className="report-item-row">
            <div className="report-item half">
              <div className="label">New Deals</div>
              <div className="item-value">{dealsData.new.count}</div>
              {this.renderDelta(dealsData.new.delta)}
            </div>
            <div className="report-item half">
              <div className="label">Won Deals</div>
              <div className="item-value">{dealsData.won.count}</div>
              {this.renderDelta(dealsData.won.delta)}
            </div>
          </div>
          {this.state.reportWeekStart === DEFAULT_START_DATE &&
            <div className="report-item-row report-item">
              <div className="label">Active Pipeline</div>
              <div className="item-value">${formatThousands(Math.ceil(dealsData.pipeline))}</div>
            </div>
          }
          {this.state.reportWeekStart === DEFAULT_START_DATE &&
            <div className="report-item-row report-item">
              <div className="label">Velocity Pipeline</div>
              <div className="item-help" data-tip="Active pipeline adjusted for deal confidence" data-for="predictive-pipeline-tooltip">{getIcon('info-bold')}<ReactTooltip id="predictive-pipeline-tooltip" /></div>
              <div className="item-value">${formatThousands(Math.ceil(dealsData.adjustedPipeline))}</div>
            </div>
          }
        </div>
      </div>
    )
  }

  renderReport(){

    const reportData = this.reportData();

    // console.log('reportData: ', reportData);

    return (
      <div className="report-sections">
        <div className="report-left">
          {this.renderReportOutcomesSection(reportData.outcome)}
          {this.renderReportActivitesSection(reportData.activity)}
        </div>
        <div className="report-right">
          {this.renderDealsSection(reportData.deals)}
          {this.renderReportDevelopmentSection(reportData.skill, reportData.behavior)}
        </div>
      </div>
    );
  }

  getReportName(){
    if(this.viewingUserData()){
      return `Weekly Report for ${this.viewingUserData().firstName} ${this.viewingUserData().lastName}`;
    }
    if(this.viewingTeamData()){
      return `Weekly Report for ${this.viewingTeamData().name}`;
    }
    else{
      return 'Organization Report Card';
    }
  }
  getReportDatesString(){
    return `${this.getReportDates().thisStart.format('MMM D')} - ${this.getReportDates().thisEnd.format('MMM D')}`;
  }

  render(){
    return (
      <div className="report win-the-week">
        <div className="content-wrapper">
          <div className="page-main-content">
            <div className="page-title">
              <h1>{this.getReportName()}</h1>
              <h3><div onClick={() => { this.goToPrevWeek(); }} className="date-advance">{getIcon('prev')}</div><div className="date-display">{this.getReportDatesString()}</div><div onClick={() => { this.goToNextWeek(); }} className={`date-advance ${DEFAULT_START_DATE === this.state.reportWeekStart ? 'disabled' : ''}`}>{getIcon('next')}</div></h3>
            </div>
            <div className="page-actions">
              <div className="select-group">
                {this.renderTeamSelect()}
                {this.renderTeamUserSelect()}
              </div>
            </div>
            <div className="page-content">
              {this.renderReport()}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    sprintHistory: state.sprintHistory.data,
    fetchingSprintHistory: state.sprintHistory.loading,
    teams: state.teams.data,
    deals: state.deals.data,
    fetchingAllDeals: state.deals.loading,
    goalOptions: state.organization.data ? state.organization.data.sprintGoals : null,
  }
}

export default connect(mapStateToProps, { fetchSprintHistoryForEveryone, fetchUserDataForEveryone, fetchDealsForEveryone })(WinTheWeekReport);



// WEBPACK FOOTER //
// ./src/components/reports/winTheWeek.js